<script>
export default {
    name: 'App',
}
</script>
<template>
    <div id="App">
        <router-view></router-view>
    </div>
</template>
<style>
</style>
